import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m14.51 13.449-1.954-1.953a4.935 4.935 0 0 0 .968-2.867c.02-1.298-.459-2.503-1.35-3.393-1.511-1.512-3.533-2.435-5.848-2.67-1.733-.176-3.025.093-3.079.104l-.476.102-.102.476c-.011.054-.28 1.346-.104 3.079.235 2.314 1.158 4.337 2.67 5.848.872.872 2.047 1.35 3.315 1.35h.078a4.937 4.937 0 0 0 2.867-.968l1.34 1.34 1.673-.448h.002ZM6.222 4.063c1.974.21 3.62.962 4.891 2.233.601.6.925 1.421.91 2.31a3.442 3.442 0 0 1-.546 1.811l-1.131-1.131V6.11h-1.5v1.675l-3.78-3.78c.347-.002.737.012 1.156.057Zm2.383 7.962c-.889.013-1.709-.31-2.31-.91-1.271-1.272-2.023-2.917-2.233-4.891-.044-.42-.058-.81-.056-1.156l3.808 3.808H6.12v1.5h3.195l1.103 1.101a3.44 3.44 0 0 1-1.812.547Z"
      }
    )
  }
);
export {
  r as Eco
};
